<template>
    <div>
        <form method="post" target="_blank" :action="routes.report">
            <input type="hidden" name="_token" :value="getCsrfToken()" />

            <div class="row mb-4">
                <div v-if="showStaff" class="col-md-3">
                    <dynamic-select
                        placeholder="Select Staff"
                        :route="routes.staffFilter"
                        v-model="filters.staff"
                    />
                </div>
                <div class="col-md-3" v-if="showVehicle">
                    <dynamic-select
                        placeholder="Select Vehicle"
                        :route="routes.vehicleFilter"
                        v-model="filters.vehicle"
                    />
                </div>
                <div class="col-md-3" v-if="showVehicle && showStaff">
                    <v-select :options="vehicleOwners" placeholder="Show All Vehicle Owners In Report" v-model="filters.vehicleType" />
                    <input type="hidden" name="filters[vehicleType]" :value="filters.vehicleType" />
                </div>
                <div class="col-md-3" v-if="showVehicle && showStaff">
                    <v-select :options="groupReportFilterOptions" placeholder="Do Not Group Report" v-model="filters.group" />
                    <input type="hidden" name="filters[group]" :value="filters.group" />
                </div>
            </div>

            <div class="row mb-4" v-if="showVehicle && showStaff">
                <div class="col-md-3">
                    <input type="text" class="form-control js-flatpickers" placeholder="Date from" name="filters[date_from]" v-model="filters.date_from" />
                </div>
                <div class="col-md-3">
                    <input type="text" class="form-control js-flatpickers" placeholder="Date to" name="filters[date_to]" v-model="filters.date_to" />
                </div>
                <div class="col-md-6 d-flex justify-content-end align-items-center">
                    <div>
                        <button type="submit" class="btn btn-sm btn-info">
                            <i class="fas fa-scroll"></i>
                            Generate Report
                        </button>
                    </div>
                </div>
            </div>
        </form>

        <table ref="table" class="table table-bordered table-striped table-vcenter dataTable">
            <thead>
                <tr>
                    <th v-if="showStaff">Staff</th>
                    <th v-if="showVehicle">Vehicle</th>
                    <th v-if="showJob">Job</th>
                    <th>Start</th>
                    <th>End</th>
                    <th>Duration</th>
                    <th></th>
                </tr>
            </thead>
            <tbody></tbody>
        </table>
    </div>
</template>

<script>
import { Eventbus } from '@/components/eventbus';
import VSelect from 'vue-select';
import DynamicSelect from "../../dynamic-select.vue";
import { createApp } from 'vue';

import ClassicsTimeEntriesAssignToVehicle from "./assignToVehicle.vue";

export default {
    components: {
        DynamicSelect,
        VSelect,
    },
    props: {
        routes: Object,
        showVehicle: {
            type: Boolean,
            default: true,
        },
        showJob: {
            type: Boolean,
            default: true,
        },
        showStaff: {
            type: Boolean,
            default: true,
        },
        vehicleOwners: {
            type: Array,
            default: () => [],
        },
    },
    data () {
        return {
            filters: {
                date_from: null,
                date_to: null,
                group: null,
                staff: null,
                vehicle: null,
                vehicleType: null,
            },
            groupReportFilterOptions: [
                'Group report by vehicle',
                'Group report by staff',
            ],
        };
    },
    mounted: function () {

        const columns = [];

        if (this.showStaff) {
            columns.push(
                {
                    name: 'staff',
                    render: function (data, type, row) {
                        return row.staff_both_names;
                    },
                }
            );
        }

        if (this.showVehicle) {
            columns.push(
                {
                    name: 'vehicle_description',
                    render: (data, type, row) => {
                        return row.vehicle_description || '<classics-time-entries-assign-to-vehicle :routes=\'' + JSON.stringify(this.routes) + '\' uuid="' + row.uuid + '"/>';
                    },
                    sortable: false,
                    searchable: false,
                },
            );
        }

        if (this.showJob) {
            columns.push(
                {
                    data: 'description',
                },
            );
        }

        columns.push(
            {
                data: 'start',
            },
            {
                data: 'end',
                render: (data, type, row) => `${row.end} ${(row.endWarning) ? '<i class="fas fa-exclamation-triangle"></i>' : ''}`,
            },
            {
                data: 'duration',
                sortable: false,
            },
            {
                data: 'actions',
                sortable: false,
            },
            {
                data: 'staff.name',
                visible: false,
            },
            {
                data: 'staff.display_name',
                visible: false,
            },
            {
                data: 'uuid',
                visible: false,
                searchable: false,
            },
        );

        let sortByStart = 0;
        columns.find((column, index) => {
            if (column.data == 'start') {
                sortByStart = index;
            }
        });

        let table = window.jQuery(this.$refs.table).on('preXhr.dt', (e, settings, data) => {
            data.filters = this.filters;
        }).DataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: this.routes.table,
            },
            order: [[sortByStart, 'desc']],
            columns: columns,
            autoWidth: false, // for some reason helps the table not *nearly* fitting on it's parent div
            drawCallback: () => {
                let n = 0;
                for (const el of this.$el.querySelectorAll('classics-time-entries-assign-to-vehicle')) {
                    const tag = el.localName;
                    const app = createApp({
                        template: el.outerHTML,
                        name: `${tag} ${++n}`,
                    });
                    app.component(tag, ClassicsTimeEntriesAssignToVehicle);
                    app.mount(el);
                }
            }
        });

        // On some pages when using this component, the columns for the tables are very small
        // and don't fill the whole width of the card. This seems to be a working fix for this problem
        for (const id of ['vehicle-timeEntries-tab', 'job-timeEntries-tab', 'staff-time-entries-tab']) {
            const elem = document.getElementById(id);
            if (!elem) {
                continue;
            }
            elem.addEventListener('shown.bs.tab', () => {
                this.$refs.table.removeAttribute('style');
                table.columns.adjust();
            })
        }

        Eventbus.on('time-entries-table-refresh', () => {
            table.ajax.reload(null, false);
        });

        // watch api to use table without saving it to data
        // also avoid datepickers needing to trigger change
        this.$watch(
            'filters',
            () => table.ajax.reload(null, false),
            {
                deep: true
            }
        );
    },

    methods: {
        getCsrfToken () {
            return document.head.querySelector('meta[name="csrf-token"]').content;
        },
    }
}
</script>
